const RELOAD_KEY = 'inovio.chunk-reload-at'
const RELOAD_WINDOW_MS = 30_000

/**
 * A hashed chunk that no longer exists after a deploy, as each browser engine
 * words it.
 *
 * The last two alternatives are not exotic: a server that answers a missing
 * chunk with index.html instead of a 404 turns the failure into a MIME
 * complaint, and Vite's preload helper reports a failed stylesheet in its own
 * words. Missing them is what showed "something went wrong" over what is only a
 * stale tab.
 */
const STALE_CHUNK_MESSAGE =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Expected a JavaScript(?: or WebAssembly)? module script|Unable to preload CSS/i

export function isStaleChunkError(error: unknown): boolean {
  return error instanceof Error && STALE_CHUNK_MESSAGE.test(error.message)
}

/**
 * Whether a chunk reload has just happened, so a chunk that keeps failing for
 * some other reason surfaces as an error instead of reloading in a loop.
 */
export function hasReloadedForChunkRecently(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
    return Date.now() - last < RELOAD_WINDOW_MS
  } catch {
    // Private mode or blocked site data: without a stamp to read, a reload loop
    // is the worse failure, so report a recent reload and let the error show.
    return true
  }
}

export function stampChunkReload(): void {
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    // Nothing to do: hasReloadedForChunkRecently() already refuses to reload here.
  }
}
